import { Dispatch } from "redux";
import { setLoading } from "./global";
import TierService from "service/Tier";
import { TierPayloadTypes } from "utilities/types/Tier";
import { showMessage } from "utilities/helper";
import { TierRewardPayloadTypes } from "utilities/types/TierReward";

export const getAllTiers =
  (filterTenant: number = 3) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    try {
      const data = await TierService.getAllTiers(filterTenant);

      dispatch(setLoading(false));
      dispatch({ type: "SET_TIER", value: data.tiers });
      dispatch({
        type: "SET_TIER_FILTER_PAGE",
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeTier =
  (form: TierPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await TierService.storeTier(payload);
      const { filterTenantPage } = getState().tierReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllTiers(filterTenantPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateTier =
  (tierId: string, form: TierPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await TierService.updateTier(tierId, payload);
      const { filterTenantPage } = getState().tierReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });
      dispatch(getAllTiers(filterTenantPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteTier =
  (tierId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await TierService.deleteTier(tierId);
      const { filterTenantPage } = getState().tierReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });
      dispatch(getAllTiers(filterTenantPage) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const getTierRewardByTierName =
  (tierName?: string, type?: string) => async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    try {
      const data = await TierService.getTierRewardByTierName(tierName);

      dispatch(setLoading(false));
      dispatch({
        type: "SET_TIER_ID",
        value: data.tier.id.toString(),
      });
      if (type === "Catalog") {
        dispatch({
          type: "SET_TIER_REWARD",
          value: data.tier.rewards.filter(
            ({ is_voucher }: any) => is_voucher === 0
          ),
        });
      } else if (type === "Voucher") {
        dispatch({
          type: "SET_TIER_REWARD",
          value: data.tier.rewards.filter(
            ({ is_voucher }: any) => is_voucher === 1
          ),
        });
      }
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeTierRewards =
  (
    tierId: string | undefined,
    form: TierRewardPayloadTypes,
    tierName: string | undefined,
    type: string | undefined,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await TierService.storeTierRewards(tierId, payload);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });
      dispatch(getTierRewardByTierName(tierName, type) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteTierReward =
  (
    tierId: string | undefined,
    tierRewardId: number,
    tierName: string | undefined,
    type: string | undefined,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await TierService.deleteTierReward(tierId, tierRewardId);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });
      dispatch(getTierRewardByTierName(tierName, type) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
